<ng-container *transloco="let t; read: 'ime.common.specs'">
  <div class="d-flex">
    <span class="mx-2">{{t('Specs')}}:</span>
    <span class="form-check form-switch ms-auto me-2">
      <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" [(ngModel)]="filterData.ShowOnlyRelevantSpecs.value" (ngModelChange)="filterData.ShowOnlyRelevantSpecs ? showOnlyRelevantSpecsChange.emit() : false">
      <label class="form-check-label" for="flexSwitchCheckDefault">{{t('Only relevant')}}</label>
    </span>
    <span class="form-check form-switch ms-2 me-2" *ngIf="showIncludeInheritedSpecs">
      <input class="form-check-input" type="checkbox" role="switch" id="includeInheritedCheck" [(ngModel)]="filterData.IncludeInheritedSpecs.value" (ngModelChange)="includeInheritedValuesChange.emit()">
      <label class="form-check-label" for="includeInheritedCheck">{{t('Include inherited')}}</label>
    </span>
    <span class="form-check form-switch ms-2 me-2" *ngIf="showIncludeSpecConstraints">
      <input class="form-check-input" type="checkbox" role="switch" id="includeConstraintsCheck" [(ngModel)]="filterData.IncludeSpecConstraints.value" (ngModelChange)="includeSpecConstraintsValuesChange.emit()">
      <label class="form-check-label" for="includeConstraintsCheck">{{t('Include constraints')}}</label>
    </span>
  </div>
  <input class="form-control mt-1" id="filterByItem" name="filterByItem" type="search" placeholder="{{t('Search specs')}}" mesAutoFocus [(ngModel)]="specSearch"/>
  <div style="max-height: calc(100vh - 500px); overflow-y: auto">
    <ng-container *ngIf="filterData.ShowOnlyRelevantSpecs.value; else listOfAllSpecs">
      <ng-container *ngFor="let spec of relevantSpecs">
        <ng-container *ngIf="(propertiesQuery.selectEntity(spec.Key) | async) as property">
          <button *ngIf="filterData.SelectedSpecs?.includes(spec.Key) && (!specSearch || (property | displayName).toLowerCase() | test : specSearch?.toLowerCase())"
                  class="dropdown-item" ngbDropdownItem [title]="property.Name" (click)="selectionChange.emit(property)">
            <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check">
            </svg>
            {{property.Code}}
          </button>
        </ng-container>
      </ng-container>
      <ng-container *ngFor="let spec of relevantSpecs">
        <ng-container *ngIf="(propertiesQuery.selectEntity(spec.Key) | async) as property">
          <button *ngIf="!filterData.SelectedSpecs?.includes(spec.Key) && (!specSearch || (property | displayName).toLowerCase() | test : specSearch?.toLowerCase())"
                  class="dropdown-item" ngbDropdownItem [title]="property.Name" (click)="selectionChange.emit(property)">
            {{property.Code}}
          </button>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #listOfAllSpecs>
      <ng-container *ngFor="let property of propertiesQuery.selectAll$ | async; trackBy: trackById">
        <button *ngIf="filterData.SelectedSpecs?.includes(property.Id) && (!specSearch || (property | displayName).toLowerCase() | test : specSearch?.toLowerCase())"
                class="dropdown-item" ngbDropdownItem [title]="property.Name" (click)="selectionChange.emit(property)">
          <svg viewBox="0 0 8 8" class="icon wx-16 hx-16 m-1" inlineSVG="#check">
          </svg>
          {{property.Code}}
        </button>
      </ng-container>
      <ng-container *ngFor="let property of propertiesQuery.selectAll$ | async; trackBy: trackById">
        <button *ngIf="!filterData.SelectedSpecs?.includes(property.Id) && (!specSearch || (property | displayName).toLowerCase() | test : specSearch?.toLowerCase())"
                class="dropdown-item" ngbDropdownItem [title]="property.Name" (click)="selectionChange.emit(property)">
          {{property.Code}}
        </button>
      </ng-container>
    </ng-template>
  </div>
</ng-container>
